module.exports = __webpack_public_path__ + "static/media/Electric.23858b92.svg";